import type {
    BookableSessionId} from "@@/shared/acquire/sessions/bookable-session-id";
import {
    bookableSessionIdZodSchema,
} from "@@/shared/acquire/sessions/bookable-session-id";
import type {
    SessionStatus} from "@@/shared/acquire/sessions/bookable-session-status";
import {
    sessionStatusZodSchema,
} from "@@/shared/acquire/sessions/bookable-session-status";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { productIdZodSchema } from "../product-id";
import type { ProductCommandCommon } from "./product-commands-common";

type BookableSetStatusSessionCommand = ProductCommandCommon & {
    readonly _id: string;
    readonly _type: "BOOKABLE_SET_STATUS_SESSION_COMMAND";
    readonly sessionId: BookableSessionId;
    readonly newStatus: SessionStatus;
};

type FactoryParams = Except<
    ProductCommandCommon & BookableSetStatusSessionCommand,
    "_id" | "_type" | "_createdAt"
>;
const bookableSetStatusSessionCommandFactory = (params: FactoryParams) => {
    const editCommand: BookableSetStatusSessionCommand = {
        ...params,
        _id: generateId({ prefix: "bookable_set_status_session_command__" }),
        _type: "BOOKABLE_SET_STATUS_SESSION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return editCommand;
};

const bookableSetStatusSessionCommandZodSchema: z.ZodSchema<BookableSetStatusSessionCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("BOOKABLE_SET_STATUS_SESSION_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        productId: productIdZodSchema,
        sessionId: bookableSessionIdZodSchema,
        newStatus: sessionStatusZodSchema,
    });

export {
    bookableSetStatusSessionCommandFactory,
    bookableSetStatusSessionCommandZodSchema,
};
export type {
    BookableSetStatusSessionCommand,
    FactoryParams as CreateBookableSetStatusSessionCommandParams,
};
